import { render } from "./AdminUserIndex.vue?vue&type=template&id=64599542"
import script from "./AdminUserIndex.vue?vue&type=script&lang=js"
export * from "./AdminUserIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__